module.exports = __webpack_public_path__ + "img/image17-1.4b307131.png";